<mat-dialog-content class="mat-typography">
    <span class="alet">{{data}}</span>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="0">No</button>
    <button mat-button [mat-dialog-close]="1" cdkFocusInitial>Si</button>
</mat-dialog-actions>


<!-- <div class="float-right">
    <button button class="flotanteDerecha accent" mat-raised-button type="button" (click)='cancelar()'>Cerrar</button>
</div> -->
